import { PureComponent } from 'react'
import { BarChartMultiple } from '../BarCharts/BarChartMultiple'
import { BarChartStackedMultiple } from '../BarCharts/BarChartStackedMultiple'
// import { EvaluationPerformMultipleTable } from './EvaluationPerformMultipleTable'
import EvaluationPerformMultipleTableCollapsible from './EvaluationPerformMultipleTableCollapsible'

export class EvaluationPerformMultiple extends PureComponent {

    // constructor(props) {
    //     super(props);
    // }

    gatherExamsResultsArray = (exams) => {
        const resultArray = exams.map(this.props.callbackPerformSingleEval);
        return resultArray;
    }

    evalResults = this.gatherExamsResultsArray(this.props.parentState.klassenarbeiten);
    overallStats = this.props.callbackPerformMultipleEval(this.evalResults);
    dummyVar = this.props.callbackSetStausExams("unchanged");

    render() {
        return (
            <>
                <BarChartMultiple evalData={this.evalResults}
                    parentState={this.props.parentState}
                    overallStats={this.overallStats} />
                <hr id="hrSpacer" />
                <BarChartStackedMultiple evalData={this.evalResults}
                    parentState={this.props.parentState}
                    overallStats={this.overallStats}
                />
                {/* <hr id="hrSpacer" />
                <EvaluationPerformMultipleTable evalData={this.evalResults}
                    overallStats={this.overallStats}
                    parentState={this.props.parentState}
                    callbackToggleShowHideCrossProduct={this.props.callbackToggleShowHideCrossProduct}
                    callbackToggleShowHideDetailsTable={this.props.callbackToggleShowHideDetailsTable} /> */}
                <hr id="hrSpacer" />
                <EvaluationPerformMultipleTableCollapsible
                    evalData={this.evalResults}
                    overallStats={this.overallStats}
                    parentState={this.props.parentState} />
            </>
        )
    }
}